import { useState } from 'react';

import { FieldEditModal } from '../FieldEditModal';
import SpecialOfferFormField from '../../PostingPath/SpecialOffers/SpecialOfferFormField';

import type { RentalManagerSpecialOfferInputsDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  defaultOffer?: Omit<RentalManagerSpecialOfferInputsDto, 'listingAlias'>;
};

const SpecialOffersModal = ({ isOpen, onClose, defaultOffer }: Props) => {
  const [description, setDescription] = useState(defaultOffer?.description ?? '');

  return (
    <FieldEditModal
      title={defaultOffer?.offerIdEncoded ? 'Edit special offer' : 'Add special offer'}
      isOpen={isOpen}
      onClose={onClose}
      isSaveDisabled={!description.trim()}
    >
      <div data-testid="SpecialOffersModal">
        <SpecialOfferFormField defaultOffer={defaultOffer} onDescriptionChange={setDescription} />
      </div>
    </FieldEditModal>
  );
};

export default SpecialOffersModal;
